import request from '@/util/request';

export const doLogin = (params) => {
    return request.post('/userLogin/doLogin', params);
};

export const doLogout = (params) => {
    return request.post('/userLogin/doLogout', params);
};

export const getUserList = (params) => {
    return request.get('/userLogin/list', { params });
};

export const kickOutUser = (userId) => {
    return request.get('/userLogin/kickOut', { params: { userId } });
};

export const updateUser = (params) => {
    return request.post('/userLogin/update', params);
};

export const deleteUser = (params) => {
    return request.post('/userLogin/delete', params);
};

export const addUser = (params) => {
    return request.post('/userLogin/add', params);
};

// 绑定角色
export const bindRole = (params) => {
    return request.post('/userLogin/bindRole', params);
};

// 获取用户角色
export const getUserRole = (userId) => {
    return request.get('/userLogin/getBindRole', { params: { userId } });
};

// 解绑角色
export const unbindRole = (params) => {
    return request.post('/userLogin/unbindRole', params);
};

// 绑定用户到项目
export const bindUserToProject = (params) => {
    return request.post('/userLogin/bindProject', params);
};

// 获取用户已绑定项目
export const getUserBindProject = (userId) => {
    return request.get('/userLogin/getUserProject', { params: { userId } });
};

// 解绑项目
export const unbindProject = (params) => {
    return request.post('/userLogin/unbindProject', params);
};

// 登陆获取验证码
export const getVerifyCode = (params) => {
    return request.get('/userLogin/getVerifyCode', { params });
};

// 获取修改密码验证码
export const getChangePasswordVerifyCode = (params) => {
    return request.get('/userLogin/getVerifyCodeByEditPassword', { params });
};

// 修改密码
export const changePassword = (params) => {
    return request.post('/userLogin/updatePassword', params);
};

// 获取个人信息
export const getUserInfo = () => {
    return request.get('/userLogin/getMyInfo');
};

// 按角色名称和项目获取已绑定用户
export const getUsersByRoleNameAndProject = (roleName, compUuid) => {
    return request.get('/userLogin/listByRoleNameAndCompUuid', {
        params: { roleName, compUuid }
    });
};

// 修改个人信息
export const updateUserInfo = (params) => {
    return request.post('/userLogin/updateMyInfo', params);
};

// 解除用户登录锁定
export const unLockUser = (username) => {
    return request.get('/userLogin/unlockUser', { params: { username } });
};

// 弹窗于用户客户端
export const popupUser = (params) => {
    return request.get('/systemPush/sendPrivate', { params });
};

// 获取根据项目id获取维保人员列表
export const maintainerList = (compUuid) => {
    return request.get(`/userLogin/maintainerList/${compUuid}`);
};
